export default "__VITE_ASSET__B4Uya18S__"